<md-content-box class="lesson-block" [type]="isFeedbackInvalid() ? 'error' : 'default'">
	<md-icon icon="untitled-ui/editor/pencil-line"></md-icon>
	<div class="lesson-block__body">
		<div class="lesson-block__header">
			<div class="lesson-block__title">
				<md-header size="xs">Lesson Feedback</md-header>
			</div>
			<!-- @if (!isReadOnly()) {
				<div class="generate-section">
					<button md-button class="generate-btn" [disabled]="isGenerating()" (click)="generate()">
						<md-icon icon="untitled-ui/shapes/star-06"></md-icon>
						{{ isGenerating() ? 'Generating...' : 'Generate with AI' }}
					</button>
					@if (generateError()) {
						<span class="generate-error"><md-icon icon="untitled-ui/alerts/alert-triangle"></md-icon>{{ generateError() }}</span>
					}
				</div>
			} -->
		</div>

		<div class="lesson-block__content">
			@if (!isReadOnly()) {
				<!-- Chirp rooms have no single learner to write up, so they collect notes only. -->
				@if (collectsFeedback()) {
					<div class="feedback-field" [class.feedback-field--error]="isAreasOfStrengthInvalid()">
						<lb-audio-transcribe-input [languageID]="state.lesson()?.languageID ?? null" [disabled]="fieldsDisabled()">
							<label label class="feedback-field__label" for="areas-of-strength"
								>Areas of Strength <span class="feedback-field__required">*</span></label
							>
							<textarea
								id="areas-of-strength"
								md-form-inputs
								placeholder="What did the learner do well this lesson?"
								[disabled]="fieldsDisabled()"
								[value]="areasOfStrength()"
								(input)="onAreasOfStrengthChange($any($event.target).value)"
								rows="5"
							></textarea>
						</lb-audio-transcribe-input>
					</div>

					<div class="feedback-field" [class.feedback-field--error]="isAreasOfImprovementInvalid()">
						<lb-audio-transcribe-input [languageID]="state.lesson()?.languageID ?? null" [disabled]="fieldsDisabled()">
							<label label class="feedback-field__label" for="areas-of-improvement">
								Areas of Improvement <span class="feedback-field__required">*</span>
							</label>
							<textarea
								id="areas-of-improvement"
								md-form-inputs
								placeholder="What should the learner focus on?"
								[disabled]="fieldsDisabled()"
								[value]="areasOfImprovement()"
								(input)="onAreasOfImprovementChange($any($event.target).value)"
								rows="5"
							></textarea>
						</lb-audio-transcribe-input>
					</div>
				}

				<div class="feedback-field feedback-field--grow">
					@if (generatedSummary()) {
						<div class="generated-preview">
							<div class="generated-preview__header">
								<md-icon icon="untitled-ui/shapes/star-06"></md-icon>
								<md-header size="xs">AI-Generated Notes</md-header>
							</div>
							<lb-rich-text-view class="generated-preview__body" [content]="generatedSummary()" />
							<div class="generated-preview__actions">
								<button md-button md-button-type="primary" (click)="acceptGenerated()">Accept</button>
								<button md-button (click)="discardGenerated()">Discard</button>
							</div>
						</div>
					}

					<lb-audio-transcribe-input [languageID]="state.lesson()?.languageID ?? null" [disabled]="fieldsDisabled()">
						<label label class="feedback-field__label" for="lesson-summary"
							>Lesson Notes <span class="feedback-field__optional">(optional)</span></label
						>
						<textarea
							id="lesson-summary"
							md-form-inputs
							placeholder="Add any additional notes"
							[disabled]="fieldsDisabled()"
							[value]="summary()"
							(input)="onSummaryChange($any($event.target).value)"
							rows="5"
						></textarea>
					</lb-audio-transcribe-input>
				</div>
			} @else {
				<div class="feedback-display">
					<!-- Mirrors the editor above: rooms never collect these, so don't show empty states for them. -->
					@if (collectsFeedback()) {
						<div class="feedback-display__field">
							<label class="feedback-field__label">Areas of Strength</label>
							@if (areasOfStrength()) {
								<lb-rich-text-view [content]="areasOfStrength()" />
							} @else {
								<span class="empty-state">No areas of strength recorded.</span>
							}
						</div>

						<div class="feedback-display__field">
							<label class="feedback-field__label">Areas of Improvement</label>
							@if (areasOfImprovement()) {
								<lb-rich-text-view [content]="areasOfImprovement()" />
							} @else {
								<span class="empty-state">No areas of improvement recorded.</span>
							}
						</div>
					}

					<div class="feedback-display__field">
						<label class="feedback-field__label">Lesson Notes</label>
						@if (summary()) {
							<lb-rich-text-view [content]="summary()" />
						} @else {
							<span class="empty-state">No lesson notes available.</span>
						}
					</div>
				</div>
			}
		</div>
	</div>
</md-content-box>
